import * as yup from 'yup'

export const getUserImportSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    company_id: yup.number().nullable().typeError(__('Employer is required')).required(__('Employer is required')),
    file: yup.mixed().required(__('File is required'))
  })
}

export const getCreateUserSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    company_id: yup.number().required(__('Company is required')),
    first_name: yup.string().required(__('First name is required')),
    employee_id: yup.string().required(__('User Code is required')),
    birth_date: yup.string().required(__('Birth date is required')),
    // phone_code: yup.string().required(__('Phone code is required')),
    // phone: yup.string().required(__('Phone is required')),
    email: yup.string().email(__('Invalid email')).required(__('Email is required')),
    role_id: yup.number().when('company_id', {
      is: (companyId: number) => companyId === 1,
      then: schema => schema.required(__('Role is required')),
      otherwise: schema => schema.notRequired()
    })
  })
}

export const getCreateEmployeeSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    company_id: yup.number().nullable().typeError(__('Employer is required')).required(__('Employer is required')),
    first_name: yup
      .string()
      .test('no-leading-space', __('Cannot start with space'), value => value == null || !/^\s/.test(value))
      .required(__('First name is required')),
    phone_code: yup.string().required(__('Phone code is required')),
    phone: yup.string().required(__('Phone is required')),
    bank_account_name: yup
      .string()
      .test('no-leading-space', __('Cannot start with space'), value => value == null || !/^\s/.test(value))
      .required(__('Bank account name is required'))
      .matches(/^[A-Z\s]+$/, __('Bank account name must be uppercase and contain no accents')),
    bank_id: yup.number().nullable().typeError(__('Bank Name is required')).required(__('Bank Name is required')),
    employee_id: yup
      .string()
      .test('no-leading-space', __('Cannot start with space'), value => value == null || !/^\s/.test(value))
      .required(__('Employee ID is required')),
    bank_account_number: yup
      .string()
      .required(__('Bank account  is required'))
      .typeError(__('Bank account must be a number'))
  })
}

export const getChangePhoneSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    phone_code: yup.string().required(__('Phone code is required')),
    phone: yup.string().required(__('Phone is required')),
    phone_new: yup.string().required(__('Information missing. Please complete this field.'))
  })
}

export const getMappingEmployeeSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    company_id: yup.number().required(__('Company is required')),
    from: yup.number().required(__('From is required')),
    to: yup.number().required(__('To is required'))
  })
}

export const getGuestmployeeSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    // Required fields for validation
    company_id: yup.number().required(__('Company is required')),
    first_name: yup.string().required(__('First name is required')),
    bank_account_name: yup
      .string()
      .required(__('Bank account name is required'))
      .matches(/^[A-Z\s]+$/, __('Bank account name must be uppercase and contain no accents')),
    bank_id: yup.number().required(__('Bank name is required')),
    employee_id: yup.string().required(__('Employee ID is required')),
    bank_account_number: yup
      .string()
      .required(__('Bank account  is required'))
      .typeError(__('Bank account must be a number')),

    // Optional fields
    contract_type: yup.string(),
    dob: yup.string(),
    email: yup.string(),
    phone: yup.string(),
    working_date: yup.string(),
    companyName: yup.string(),
    employeeId: yup.string(),
    businessRegistration: yup.string(),
    address: yup.string(),
    companyEmail: yup.string(),
    companyPhone: yup.string(),
    department: yup.string(),
    joined_date: yup.string(),
    identity_card: yup.string(),
    identity_card_issue_date: yup.string(),
    identity_card_issue_place: yup.string(),
    gender: yup.string(),
    dependent: yup.string(),
    tenure: yup.string()
  })
}
